export default __webpack_public_path__ + "static/media/tour_360.f981e87f.mp4";